import { render, staticRenderFns } from "./perguntas-frequentes.vue?vue&type=template&id=0ab27439"
import script from "./perguntas-frequentes.vue?vue&type=script&lang=js"
export * from "./perguntas-frequentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports